import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormControl, UntypedFormGroup, ValidationErrors, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { OnlineStatusService, OnlineStatusType } from 'ngx-online-status';
import { AuthenticationService } from '../../services/authentication.service';
import { SharedMethodsService } from '../../services/shared-methods.service';
import { ValidationService } from '../../services/validation.service';
import { encoders, Whirlpool } from 'whirlpool-hash';

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.css'],
    standalone: false
})
export class ResetPasswordComponent implements OnInit {

  // form validator error messages
  passwordError: string = 'Required';

  //When waiting on requests
  isResetting: boolean = false;
  newPasswordHide: boolean = true;
  confirmPasswordHide: boolean = true;

  token: string = '';
  email: string = '';

  resetForm: UntypedFormGroup = new UntypedFormGroup({
    newPassword: new FormControl<string>('', [Validators.required, Validators.minLength(8), Validators.maxLength(50)]),
    confirmPassword: new FormControl<string>('', [Validators.required, Validators.minLength(8), Validators.maxLength(50)]),
  },
    { validators: [ValidationService.match('newPassword', 'confirmPassword')] }
  );

  constructor(
    private authenticationService: AuthenticationService,
    private router: Router,
    private onlineStatusService: OnlineStatusService,
    public sharedMethodsService: SharedMethodsService,
    private route: ActivatedRoute
  ) { }



  /*  ---------- Initialization ---------- */


  ngOnInit(): void {

    this.route.queryParams
      .subscribe((params: Params) => {
        this.token = params.token;
        this.email = params.email;
      });
    this.validatePassword();

  }


  /*  ---------- Validation Methods ---------- */


  validatePassword(): void {

    let password: AbstractControl<any, any> | null = this.resetForm.get('newPassword');

    password?.valueChanges.subscribe(() => {
      this.resetForm.controls.confirmPassword.updateValueAndValidity();
      let newPasswordErrors: ValidationErrors | null | undefined = password?.errors;
      if (newPasswordErrors?.required) {
        this.passwordError = 'Required';
      }
      else if (newPasswordErrors?.minlength) {
        this.passwordError = 'Minimum length 8 required';
      }
      else if (newPasswordErrors?.maxlength) {
        this.passwordError = 'Maximum length 50 exceeded';
      }
      else {
        this.passwordError = '';
      }
    });

  }


  /*  ---------- Reset Methods ---------- */


  // attempt to sign up for an account
  attemptReset(): void {

    if (this.onlineStatusService.getStatus() === OnlineStatusType.OFFLINE) {
      this.sharedMethodsService.toastOfflineError();
      return;
    }

    // check signup entry validity
    if (this.resetForm.invalid) {
      this.sharedMethodsService.toastPasswordsNotMatching();
      return;
    }

    this.isResetting = true;
    let password = this.resetForm.get('newPassword')?.value;
    let hash = encoders.toBase64(new Whirlpool().getHash(password).toString());

    this.authenticationService.postPasswordChange(this.email, this.token, password, hash).subscribe(() => {
      this.sharedMethodsService.toastPasswordChanged();
      this.backToLogin();
    }, (err: any) => {
      console.log(err);
      this.isResetting = false;
      this.sharedMethodsService.toastSomethingWentWrong();
    });

  }


  /*  ---------- Misc Methods ---------- */


  // go back to the login screen
  backToLogin(): void {

    this.router.navigate(['login']);

  }

}
